var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eye-exam-card',{staticClass:"medical-record-exam-view",attrs:{"title":"Campo Visual","patient-id":_vm.patientId,"record-id":_vm.recordId,"exam-id":_vm.examId,"inputs":_vm.data,"rows-definition":_vm.table.body,"date":_vm.date,"show-edit-button":_vm.showEditButton},on:{"edit":function($event){return _vm.$emit('edit')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }